import { createV3Queries } from "@query/utils/createV3Queries";
import { formsApi } from "@api";

export const queriesForms = createV3Queries("formsApi", formsApi);
